export default __webpack_public_path__ + "static/media/teams.3a040360.png";